export default [
  {
    path: '/saque',
    name: 'app-financeiro-saque',
    component: () => import('@/views/apps/financeiro/list/saque.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Solicitar Resgate',
      action: 'read',
      resource: 'Analytics',
      breadcrumb: [
        {
          text: 'Solicitar Resgate',
          active: true,
        },
        {
          text: 'Minhas Solicitações',
          active: false,
          to: { name: 'app-financeiro-solicitacoes' },
        },
      ],
    },
  },
  {
    path: '/pagamentos',
    name: 'app-financeiro-pagamentos',
    component: () => import('@/views/apps/financeiro/list/pagamentos.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Aprovação de Resgates',
      action: 'read',
      resource: 'Analytics',
    },
  },
  {
    path: '/saque-solicitacoes',
    name: 'app-financeiro-solicitacoes',
    component: () => import('@/views/apps/financeiro/list/solicitacoes.vue'),
    meta: {
      requiresAuth: true,
      pageTitle: 'Minhas Solicitações',
      action: 'read',
      resource: 'Analytics',
      breadcrumb: [
        {
          text: 'Solicitar Resgate',
          to: { name: 'app-financeiro-saque' },
          active: false,
        },
        {
          text: 'Minhas Solicitações',
          active: true,
        },
      ],
    },
  },
]
